export const auditEventTracker = (playerName, eventNbr, process, calcEventObj, checkTotalsObj) => {

    let errorArr = [];
    if (calcEventObj.cash ){
         if( +calcEventObj.cash !== +checkTotalsObj.beforeCash){
            const errorLine = {player: playerName, eventNbr: eventNbr, process: process, 
               subProcess: calcEventObj.subProcess, errorFld: "Current Cash", 
               calculatedValue: calcEventObj.cash, gameValue: checkTotalsObj.beforeCash }
            errorArr.push(errorLine);
         }
    }
    if (calcEventObj.moodPoints ){ 
         if (+calcEventObj.moodPoints !== +checkTotalsObj.beforeMoodPoints){
            const errorLine = {player: playerName, eventNbr: eventNbr, process: process, 
               subProcess: calcEventObj.subProcess, errorFld: "Current Mood Points", 
               calculatedValue: calcEventObj.moodPoints, gameValue: checkTotalsObj.beforeMoodPoints }
            errorArr.push(errorLine);
         }
    }
    switch (calcEventObj.tableType){
         case "asset":
            if (+calcEventObj.newTableTotal !== +checkTotalsObj.totalAssets){
               const errorLine = {player: playerName, eventNbr: eventNbr, process: process, 
                  subProcess: calcEventObj.subProcess, errorFld: "Total Asset Amount", 
                  calculatedValue: calcEventObj.newTableTotal, gameValue: checkTotalsObj.totalAssets };
               errorArr.push(errorLine);
            }
            break;
         case "expense":
            if (+calcEventObj.newTableTotal !== +checkTotalsObj.totalExpenses){
               const errorLine = {player: playerName, eventNbr: eventNbr, process: process, 
                  subProcess: calcEventObj.subProcess, errorFld: "Total Expense Amount", 
                  calculatedValue: calcEventObj.newTableTotal, gameValue: checkTotalsObj.totalExpenses };
               errorArr.push(errorLine);
            }
            break;
         case "loan":
            if (+calcEventObj.newTableTotal !== +checkTotalsObj.totalLoans){
               const errorLine = {player: playerName, eventNbr: eventNbr, process: process, 
                  subProcess: calcEventObj.subProcess, errorFld: "Total Loan Amount", 
                  calculatedValue: calcEventObj.newTableTotal, gameValue: checkTotalsObj.totalLoans };
               errorArr.push(errorLine);
            }
            break;
         default:
            break;
    }
   
   return errorArr;
}

export default auditEventTracker;